export function isNotifyTrigger(trigger) {
    return trigger.type === 'notify';
}
export function isRedirectTrigger(trigger) {
    return trigger.type === 'redirect';
}
export function isQueryTrigger(trigger) {
    return trigger.type === 'query';
}
export function isExecuteTrigger(trigger) {
    return trigger.type === 'execute';
}
